import { render, staticRenderFns } from "./AddonProducts.vue?vue&type=template&id=207a8fbe"
import script from "./AddonProducts.vue?vue&type=script&lang=js"
export * from "./AddonProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports